/**
 * ShapeInventory — the player's collected polyomino shapes.
 *
 * Each shape contributes its cell count toward bonus grid tiles.
 */

import { ShapeDef } from "./ShapeCatalog";

export class ShapeInventory {
  private shapes: ShapeDef[] = [];

  add(def: ShapeDef): void {
    this.shapes.push(def);
  }

  remove(index: number): void {
    this.shapes.splice(index, 1);
  }

  getAll(): ReadonlyArray<ShapeDef> {
    return this.shapes;
  }

  /** Total bonus tiles contributed by all collected shapes. */
  totalBonusTiles(): number {
    let total = 0;
    for (const s of this.shapes) {
      total += s.shape.size;
    }
    return total;
  }

  get count(): number {
    return this.shapes.length;
  }
}
